export default "__VITE_ASSET__13be9243__"